import Lenis from 'lenis';

let lenis = null;

export default function initLenis() {
    if (lenis) return lenis;

    lenis = new Lenis({
        smooth: true,
        multiplier: 1.5,
        easing: (t) => t * (2 - t),
        smoothTouch: true,
        lerp: 0.08,
        duration: 0.8,
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    window.lenis = lenis;

    return lenis;
}
